module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "llra-wrap"
  }, [_c('modal', {
    staticClass: "addLuckyRunner llra-modal",
    attrs: {
      "name": "addLuckyRunner",
      "adaptive": true,
      "scrollable": true,
      "height": "auto",
      "width": "90%",
      "maxWidth": 560
    },
    on: {
      "before-close": _vm.onClose
    }
  }, [_c('div', {
    staticClass: "llra-dialog"
  }, [_c('div', {
    staticClass: "llra-dialog-header"
  }, [_c('div', {
    staticClass: "llra-dialog-header-left"
  }, [_c('span', {
    staticClass: "llra-dialog-icon"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M20 7h-3V5a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v2H4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5 7l1 14h12l1-14"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12 11v6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M9 14h6"
    }
  })])]), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "llra-dialog-title"
  }, [_vm._v("Add Lucky LiveRunner")]), _vm._v(" "), _c('p', {
    staticClass: "llra-dialog-sub"
  }, [_vm._v("Create a gift record for a race participant")])])]), _vm._v(" "), _c('button', {
    staticClass: "llra-close-btn",
    attrs: {
      "type": "button",
      "title": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.$modal.hide('addLuckyRunner')
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('line', {
    attrs: {
      "x1": "18",
      "y1": "6",
      "x2": "6",
      "y2": "18"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "6",
      "y1": "6",
      "x2": "18",
      "y2": "18"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "llra-dialog-body"
  }, [_c('div', {
    staticClass: "llra-id-grid"
  }, [_c('div', {
    staticClass: "llra-field"
  }, [_c('label', {
    staticClass: "llra-label"
  }, [_vm._v("Race Id")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.luckyRunnerData.raceId),
      expression: "luckyRunnerData.raceId"
    }],
    staticClass: "llra-input",
    domProps: {
      "value": (_vm.luckyRunnerData.raceId)
    },
    on: {
      "change": _vm.changeHandle,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.luckyRunnerData, "raceId", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "llra-field"
  }, [_c('label', {
    staticClass: "llra-label"
  }, [_vm._v("Runner Id")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.luckyRunnerData.runnerId),
      expression: "luckyRunnerData.runnerId"
    }],
    staticClass: "llra-input",
    domProps: {
      "value": (_vm.luckyRunnerData.runnerId)
    },
    on: {
      "change": _vm.changeHandle,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.luckyRunnerData, "runnerId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.invalidError) ? _c('p', {
    staticClass: "llra-error"
  }, [_vm._v(_vm._s(_vm.invalidMsg))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "llra-field"
  }, [_c('label', {
    staticClass: "llra-label"
  }, [_vm._v("Sent")]), _vm._v(" "), _c('div', {
    staticClass: "llra-date-field"
  }, [_c('date-field', {
    attrs: {
      "name": "presentSentDate"
    },
    model: {
      value: (_vm.luckyRunnerData.presentSentDate),
      callback: function($$v) {
        _vm.$set(_vm.luckyRunnerData, "presentSentDate", $$v)
      },
      expression: "luckyRunnerData.presentSentDate"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "llra-field"
  }, [_c('label', {
    staticClass: "llra-label"
  }, [_vm._v("What")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.luckyRunnerData.presentContent),
      expression: "luckyRunnerData.presentContent"
    }],
    staticClass: "llra-input",
    domProps: {
      "value": (_vm.luckyRunnerData.presentContent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.luckyRunnerData, "presentContent", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "llra-field"
  }, [_c('label', {
    staticClass: "llra-label"
  }, [_vm._v("Note")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.luckyRunnerData.note),
      expression: "luckyRunnerData.note"
    }],
    staticClass: "llra-textarea",
    domProps: {
      "value": (_vm.luckyRunnerData.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.luckyRunnerData, "note", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "llra-dialog-footer"
  }, [_c('button', {
    staticClass: "llra-cancel-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$modal.hide('addLuckyRunner')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "llra-save-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.Save()
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "13",
      "height": "13",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "17 21 17 13 7 13 7 21"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "7 3 7 8 15 8"
    }
  })]), _vm._v("\n          Save\n        ")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79ab192c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/AddLuckyLiveRunner.vue
// module id = 1732
// module chunks = 2